import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'INPUT', {
  FILE_PLACEHOLDER: 'Select or drag a file',
  FILE_MULTIPLE_PLACEHOLDER: 'Select or drag files',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'INPUT', {
  FILE_PLACEHOLDER: 'Seleccione o arrastre un archivo',
  FILE_MULTIPLE_PLACEHOLDER: 'Seleccione o arrastre archivos',
});
